/* 
 * 供应商管理
 */

// 获取供应商列表
export const mGetPurchaserList = (params) => {
  const purchaserList = {
    "code": 0,
      "msg": null,
      "data": [
        {
          "id": 1,
          "name": '1号集运站',
          "address": '北京市朝阳区叶青大厦1',
          "concat": '刘德华',
          "concatPhone": '13200001234',
          "miniappPhone": '13200001234',
          "coalModal": '块煤',
          "account": "10000.00",
          "load": 100,
          "number": 10,
          "dayLoad": 50,
          "more": true,
          "check": 0,
          "status": 0
        },
        {
          "id": 2,
          "name": '2号集运站',
          "address": '北京市朝阳区望京soho',
          "concat": '刘德华',
          "concatPhone": '13200001234',
          "miniappPhone": '13200001234',
          "coalModal": '块煤',
          "account": "10000.00",
          "load": 100,
          "number": 10,
          "dayLoad": 50,
          "more": true,
          "check": 0,
          "status": 0
        }
      ]
  }
  
  return {
    url: 'purchaser/list',
    method: 'get',
    data: purchaserList
  }
}